import React from "react";
import {
  Button,
  Col,
  Dropdown,
  Layout,
  Menu,
  Row,
  Space,
  Spin,
  Typography
} from "antd";
import Page, { PageProps } from "../../../core/ui/pages/Page";
import SearchCriteriaForm from "../components/SearchCriteriaForm";
import { ISearchResultsPresenter } from "../../presenter/SearchResultsPresenter";
import SearchResultList from "../components/SearchResultList";
import HeroSearchBar from "../components/HeroSearchBar";
import SortOrderDropdown from "../components/SortOrderDropdown";
import { PlusOutlined } from "@ant-design/icons";
import SearchCriteriaSummaryCard from "../components/SearchCriteriaSummaryCard";
import { CollectionTypes } from "../../common/Constants";
const { Content, Sider } = Layout;
const { Title } = Typography;

export interface Props extends PageProps {}

export interface State extends ISearchResultsPresenter {}

export default class SearchResultsPage extends React.Component<Props, State> {
  private subscriptionId: number = 0;

  constructor(props: any) {
    super(props);
    this.state = { ...props };
    this.onSelectNewRecordMenuItem = this.onSelectNewRecordMenuItem.bind(this);
  }

  componentDidMount() {
    this.subscriptionId = this.state.store.subscribe((result) => {
      return this.setState((prevState) => result);
    });
  }

  componentWillUnmount() {
    this.state.store.unsubscribe(this.subscriptionId);
  }

  onSelectNewRecordMenuItem({ key }) {
    if (key === CollectionTypes.STAV) {
      return this.state.createNewCaseLawDocument();
    }
    if (key === CollectionTypes.ODLUKA) {
      return this.state.createNewCaseDecision();
    }
    if (key === CollectionTypes.PRAVNO_SHVATANJE) {
      return this.state.createNewLegalView();
    }
  }

  render() {
    const { translate, router } = this.props;
    const {
      searchResults,
      searchQuery,
      onSearch,
      indexTrees,
      organisations,
      createNewCaseLawDocument,
      createNewCaseDecision,
      createNewLegalView,
      sortFields,
      loaders,
      canCreateDocuments,
      application,
      removeSelectedDate,
      currentLanguage,
      enrichedSearchQuery,
      onSearchItemClick,
      user
    } = this.state;
    const summary = searchResults?.summary;
    const selectedDocumentStatuses = searchQuery?.status?.split(",");

    const newRecordMenuItemLabels = {
      [CollectionTypes.STAV]: translate(
        "editors.case_law_documents.add_new_text"
      ),
      [CollectionTypes.ODLUKA]: translate(
        "editors.case_decisions.add_new_text"
      ),
      [CollectionTypes.PRAVNO_SHVATANJE]: translate(
        "editors.legal_views.add_new_text"
      )
    };

    const menu = (
      <Menu onClick={this.onSelectNewRecordMenuItem}>
        <Menu.Item key={CollectionTypes.STAV}>
          {newRecordMenuItemLabels[CollectionTypes.STAV]}
        </Menu.Item>
        <Menu.Item key={CollectionTypes.ODLUKA}>
          {newRecordMenuItemLabels[CollectionTypes.ODLUKA]}
        </Menu.Item>
        <Menu.Item key={CollectionTypes.PRAVNO_SHVATANJE}>
          {newRecordMenuItemLabels[CollectionTypes.PRAVNO_SHVATANJE]}
        </Menu.Item>
      </Menu>
    );
    return (
      <Page {...this.props}>
        {
          <Spin spinning={false}>
            <Layout>
              <Sider
                className={"content-container dashboard-sider search-sider"}
                breakpoint="xl"
                collapsible={false}
                collapsedWidth="0"
                width={"22%"}
              >
                <SearchCriteriaForm
                  searchQuery={searchQuery}
                  selectedYears={searchQuery?.year?.split(",")}
                  selectedDecisionYears={searchQuery?.decision_date?.split(",")}
                  selectedOrganisations={searchQuery?.organisation?.split(",")}
                  selectedIndexTypes={searchQuery?.index?.split(",")}
                  facets={searchResults?.facets}
                  translate={translate}
                  organisations={organisations || []}
                  onUpdateCriteria={onSearch}
                  indexTrees={indexTrees}
                  indexLoading={loaders.criteria}
                  organisationsLoading={loaders.criteria}
                  showStatusFilter={!application.isPortal()}
                  user={user}
                  selectedDocumentStatuses={selectedDocumentStatuses}
                  removeSelectedDate={removeSelectedDate}
                />
              </Sider>
              <Layout className={"dashboard-content-wrapper"}>
                <Content
                  className="site-layout-background dashboard-content-container"
                  id="search_results"
                >
                  <Row className="w-100 mx-0" gutter={[0, 24]}>
                    <Col xs={24} sm={24}>
                      <HeroSearchBar
                        navigator={this.props.router}
                        defaultValue={searchQuery?.phrase || ""}
                        placeholder={translate("search.bar.placeholder")}
                        searchActionLabel={translate(
                          "search.bar.search_action"
                        )}
                        advancedSearchHref="/advanced-search"
                        advancedSearchLabel={translate(
                          "search.bar.advanced_search_action"
                        )}
                        onSearch={onSearch}
                      />
                    </Col>
                    <Col xs={24} sm={24}>
                      <SearchCriteriaSummaryCard
                        translate={translate}
                        loading={this.state.loaders?.criteria}
                        query={enrichedSearchQuery}
                      />
                    </Col>
                    <Col xs={24} sm={10}>
                      <Title level={4}>
                        {translate("search.search_results_title")}
                      </Title>
                    </Col>
                    <Col
                      xs={24}
                      sm={14}
                      className="align-left align-sm-right no-print"
                    >
                      <SortOrderDropdown
                        translate={translate}
                        sortFields={sortFields}
                        field={searchQuery?.sortField || sortFields[0]}
                        sortOrder={searchQuery?.sortOrder || "asc"}
                        onChangeSortOrder={(field, sortOrder) => {
                          onSearch({
                            sortField: field,
                            sortOrder
                          });
                        }}
                      />
                    </Col>
                  </Row>
                  {canCreateDocuments ? (
                    <Row>
                      <Col
                        sm={24}
                        style={{ textAlign: "right", paddingTop: 20 }}
                      >
                        {searchQuery?.collection &&
                        searchQuery.collection.indexOf(",") == -1 ? (
                          <Button
                            style={{ textAlign: "right" }}
                            className="datagrid-add-btn"
                            type={"primary"}
                            icon={<PlusOutlined />}
                            onClick={() =>
                              this.onSelectNewRecordMenuItem({
                                key: searchQuery?.collection
                              })
                            }
                          >
                            {newRecordMenuItemLabels[searchQuery?.collection]}
                          </Button>
                        ) : (
                          <Dropdown overlay={menu} placement="bottomLeft" arrow>
                            <Button
                              style={{ textAlign: "right" }}
                              className="datagrid-add-btn"
                              type={"primary"}
                              icon={<PlusOutlined />}
                            >
                              Novi zapis
                            </Button>
                          </Dropdown>
                        )}
                      </Col>
                    </Row>
                  ) : null}

                  <SearchResultList
                    onChangePage={(page, pageSize) => {
                      onSearch({
                        page: page?.toString(),
                        pageSize: pageSize?.toString() || ""
                      });
                    }}
                    currentPage={
                      Number.parseInt(searchQuery?.page as any, 10) || 1
                    }
                    pageSize={
                      Number.parseInt(searchQuery?.pageSize as any, 10) || 20
                    }
                    router={router}
                    summary={summary}
                    loading={this.state.loaders?.search}
                    translate={translate}
                    searchResults={searchResults}
                    showSearchResultDetails={() => {}}
                    onItemClick={onSearchItemClick}
                    onSelectIndex={onSearch}
                    currentLanguage={currentLanguage}
                  />
                </Content>
              </Layout>
            </Layout>
          </Spin>
        }
      </Page>
    );
  }
}
